import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const SeoCitiesContext = createContext();

export const SeoCitiesProvider = ({
  propertyType = null,
  anchorText = null,
  currentCity,
  children
}) => (
  <SeoCitiesContext.Provider
    value={{
      propertyType,
      anchorText,
      cityId: currentCity.id,
      currentCity
    }}
  >
    {children}
  </SeoCitiesContext.Provider>
);

SeoCitiesProvider.propTypes = {
  propertyType: PropTypes.string,
  anchorText: PropTypes.string,
  currentCity: PropTypes.shape({
    id: PropTypes.string,
    currencyIsoCode: PropTypes.string,
    maximumPrice: PropTypes.number,
    cityName: PropTypes.string,
    country: PropTypes.shape({
      countryIsoCode: PropTypes.string
    }),
    minimumStaying: PropTypes.number,
    center: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    })
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export const useSeoCitiesContext = () => useContext(SeoCitiesContext);

export default SeoCitiesContext;
